import { css } from 'styled-components';

export const OVStyles = css``;
